export default __webpack_public_path__ + "static/media/ihzasag.5580ded6.webp";